import React from 'react';

const Solar: React.FC = () => {
  return (
    <div className="solar">
      <section className="solar-hero">
        <div className="hero-content">
          <h1>Nagoya Solar LLC</h1>
          <p>Leading the Renewable Energy Revolution</p>
        </div>
        <div className="hero-image">
          <img 
            src="https://www.nagoyainvestments.com/solar1.jpeg" 
            alt="Solar Energy Installation" 
            className="solar-hero-image"
          />
        </div>
      </section>

      <section className="solar-content">
        <div className="solar-intro">
          <p>Nagoya Investments is at the forefront of the renewable energy revolution, with a dedicated focus on solar energy projects through our subsidiary company Nagoya Solar LLC based in Louisiana.</p>
        </div>

        <div className="solar-initiatives">
          <h2>Our Solar Initiatives</h2>
          <div className="initiatives-grid">
            <div className="initiative-card">
              <h3>Louisiana</h3>
              <p>Implementing cutting-edge solar farms that harness the region's abundant sunlight, providing clean energy to local communities.</p>
            </div>
            <div className="initiative-card">
              <h3>Texas</h3>
              <p>Developing large-scale solar installations that contribute significantly to the state's energy grid, promoting resilience and sustainability.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solar; 